import React from "react";
import Wrapper from "../wrapper/Wrapper";
import * as ReactScrollToTop from "react-scroll-to-top";
import { FaChevronUp } from "react-icons/fa";
export var ScrollToTop = function ScrollToTop() {
  return /*#__PURE__*/React.createElement(ReactScrollToTop, {
    smooth: true,
    component: /*#__PURE__*/React.createElement(FaChevronUp, null),
    className: "scroll-to-top"
  });
};